import { render, staticRenderFns } from "./kline.vue?vue&type=template&id=27f8516c&scoped=true"
import script from "./kline.vue?vue&type=script&lang=js"
export * from "./kline.vue?vue&type=script&lang=js"
import style0 from "./kline.vue?vue&type=style&index=0&id=27f8516c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8516c",
  null
  
)

export default component.exports